import * as React from 'react';
import TimeTaxSupportSystemClient from '../../system';
import { DateTime } from 'luxon';
import { DatePicker, PrimaryButton } from '@fluentui/react';
import { DateCustom } from '../../lib/DateCustom';
import MessageCourier from '../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { getLocalizedStrings } from '../../lib/LocalizedStringsForDatePicker';
import { User } from '../../system/User';
import useIsMobile from '../../common/custom-hooks/useIsMobile';

interface IReportingFiltersPeriodo {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  onChangePeriodDate: (date: DateTime) => void;
  onClickSearch: () => void;
  user?: User;
}

export const ReportingFiltersPeriodo = (props: IReportingFiltersPeriodo) => {
  const { t } = useTranslation();
  const [fromDate, setPeriodDate] = React.useState<DateTime | undefined>(undefined);
  const [shouldRefresh, setShouldRefresh] = React.useState<boolean>(false);
  const { isMobile } = useIsMobile();

  React.useEffect(() => {
    setPeriodDate(DateTime.fromJSDate(new Date()));
    props.onChangePeriodDate(DateTime.fromJSDate(new Date()));
  }, []);

  const onChangeDate = (date: Date | null | undefined, name: string) => {
    if (date) {
      if (name === 'from') {
        setPeriodDate(DateTime.fromJSDate(date));
        props.onChangePeriodDate(DateTime.fromJSDate(date));
        setShouldRefresh(!shouldRefresh);
        if (props.onChangePeriodDate) props.onChangePeriodDate(DateTime.fromJSDate(date));
      }
    }
  };

  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row mt-12">
        {isMobile ? (
          <div className="ms-Grid-col ms-sm12 mt-1" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2px' }}>
            <span className="ms-sm6">{t('Filtro')}</span>
            <PrimaryButton iconProps={{ iconName: 'Search' }} className="ms-sm6 ml-2" onClick={props.onClickSearch} text={t('Buscar')} />
          </div>
        ) : null}

        <div className="ms-Grid-col ms-md3 ms-sm6 mt-1">
          <DatePicker
            strings={getLocalizedStrings()}
            label={t('Periodo')}
            formatDate={DateCustom.formatDateMMYYYY}
            value={fromDate ? fromDate.toJSDate() : undefined}
            onSelectDate={(e) => onChangeDate(e, 'from')}
            calendarProps={{
              isDayPickerVisible: false,
              showGoToToday: false,
            }}
          />
        </div>

        <div className="ms-Grid-col ms-sm2 mt-1" style={{ display: isMobile ? 'none' : '' }}>
          <PrimaryButton iconProps={{ iconName: 'Search' }} className="mt-for-btn-search ml-2" onClick={props.onClickSearch} text={t('Buscar')} />
        </div>
      </div>
    </div>
  );
};
